module.exports = __webpack_public_path__ + "static/img/gaozhonglishi13.5f4c1bc3.jpg";